import { useEffect, useRef, useState } from 'react';
import { withWindow } from '@shared/utils/withWindow';
import { useRefinementsPanelProvider } from '../RefinementsPanel';

export const useRefinementPanelToggle = () => {
  const { isOpen: isFilterVisible, openPanel, closePanel, getTotalActiveFilterCount } = useRefinementsPanelProvider();
  return {
    isFilterVisible,
    handleFilterClick: isFilterVisible ? closePanel : openPanel,
    totalFilterSelected: getTotalActiveFilterCount()
  };
};

export const useRefinementPanelToggleController = ({ isMobileOrTablet }: { isMobileOrTablet?: boolean }) => {
  const refinementPanelToggleContainerRef = useRef<HTMLDivElement>(null);
  const [isFixedTop, setIsFixedTop] = useState(false);

  useEffect(() => {
    const handleOnScroll = () => {
      if (refinementPanelToggleContainerRef.current !== null && !isMobileOrTablet) {
        const { top } = refinementPanelToggleContainerRef.current.getBoundingClientRect();

        // TODO: 166 is distance from category text
        if (top <= 166) {
          setIsFixedTop(true);
        } else {
          setIsFixedTop(false);
        }
      }
    };

    if (isMobileOrTablet) {
      setIsFixedTop(false);
    } else {
      withWindow(window => {
        window.addEventListener('scroll', handleOnScroll);
      });
    }
    return () => {
      withWindow(window => {
        window.removeEventListener('scroll', handleOnScroll);
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMobileOrTablet]);

  return {
    refinementPanelToggleContainerRef,
    isFixedTop
  };
};
